export default __webpack_public_path__ + "assets/github-icon-0a28358b8059a8cb470707576836a777.svg";